
import { Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoaderPage from "../layout/loadingPages/LoaderPage";
import { useGetLoggedInUserDetailsQuery } from "../reactQueries/commonRQHooks";
import { useIsAuthenticated } from "@azure/msal-react";
import { saveAuthenticatedUserDetails } from "../../redux/slices/auth/authenticatedUserSlice";
import { Fragment, useEffect, useState } from "react";
import MpgErrorDialog from "../common/dialog/MpgErrorDialog";
import { signOut } from "../../common/signout/signout";
import { encryptObjectData } from "../common/utilities/crypto/dataEncryptionByCrypto";

const ProtectedGetUserDetailsRoutes = () => {

    const dispatch = useDispatch()
    const isAuthenticated = useIsAuthenticated()

    /**getting loggedIn user details */
    const {
        isSuccess,
        isFetching: isFetchingOnClientUserData,
        error,
        data: loggedInUserAccountData,
        isError,
    } = useGetLoggedInUserDetailsQuery();

    /**storing data in local storage using RTK */
    useEffect(() => {
        if (!!isAuthenticated && !!isSuccess && !!loggedInUserAccountData) {
            // const encryptedData = encryptObjectData({ objectData: loggedInUserAccountData })

            // console.log("loggedInUserAccountData:", encryptedData)

            dispatch(saveAuthenticatedUserDetails(loggedInUserAccountData))
        }
    }, [isAuthenticated, isSuccess])

    const [authCompleted, setAuthCompleted] = useState(false)
    useEffect(() => {
        if (!!isAuthenticated) {
            if (!!isFetchingOnClientUserData) {
                setAuthCompleted(false)
            } else {
                if (!!loggedInUserAccountData) {
                    setAuthCompleted(true)
                } else {
                    setAuthCompleted(false)
                }
            }
        } else {
            setAuthCompleted(false)
        }
    }, [isAuthenticated, isFetchingOnClientUserData, loggedInUserAccountData])

    /** redirect user if this API call fails, on ok click in errorBox */
    const redirectToMSLogin = () => {
        signOut()
    }

    const errorCode = error?.response?.status
    return (
        <Fragment>
            {
                !!authCompleted ? <Outlet /> : <LoaderPage />
            }

            {
                (!!errorCode && errorCode === 403) ? (
                    <MpgErrorDialog
                        open={!!isError}
                        title="Oops, Access Denied...!"
                        content="It seems you do not have access to Admin Portal. Please verify and try again."
                        extraLogicHandlerOnOK={
                            () => {
                                redirectToMSLogin()
                            }
                        }
                    />
                ) :
                    (
                        !!errorCode && errorCode !== 401 && (<MpgErrorDialog
                            open={!!isError && !!isAuthenticated}
                            extraLogicHandlerOnOK={
                                () => {
                                    redirectToMSLogin()
                                }
                            }
                        />)
                    )
            }


        </Fragment>

    )
}

export default ProtectedGetUserDetailsRoutes;